//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"LeftChildFlow",0,"Expression",0],[1,"RightChildFlow",0,"Expression",0],[1,"SelectedPort",0,"SelectNXObject",0],[0,"SplitDirection",1,0]],[[[],"CreateDivisions",{R_:{division:"Routing.Division"}},0,0],[[],"GetDivision",{R_:{division:"Routing.Division"}},0,0]],[]];
SPLM.Routing.DivisionsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DivisionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.DivisionsBuilder.SplitDirectionType = Object.freeze({
    "SplitVertically" : "SplitVertically", "SplitHorizontally" : "SplitHorizontally"});

export default SPLM;